import axios from 'axios'

const get = async (cep) => {
  return await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
}

export default { get }
